import { Facebook, LinkedIn, Mail, X } from '@mui/icons-material';
import { type CSSProperties, Link, Stack, type SvgIconProps, Typography } from '@mui/material';
import type { ElementType } from 'react';

const SOCIAL_TYPES: Record<string, ElementType<SvgIconProps>> = {
  email: props => <Mail {...props} />,
  facebook: props => <Facebook {...props} />,
  twitter: props => <X {...props} />,
  linkedin: props => <LinkedIn {...props} />,
};

export type SocialMediaProps = {
  name: string;
  type: string;
  url: string;
  iconOnly?: boolean;
  size?: CSSProperties['fontSize'];
};

export function SocialMedia({
  name,
  type,
  url,
  iconOnly = false,
  size = 'large',
}: SocialMediaProps) {
  const IconComponent = SOCIAL_TYPES[type];
  if (!IconComponent) return null;
  return (
    <Link href={url} target="_blank" rel="noopener noreferrer" aria-label={name}>
      <Stack
        spacing={1}
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        <IconComponent sx={{ fontSize: size }} />
        {!iconOnly && (
          <Typography component="span" sx={{ display: { xs: 'none', md: 'inline-block' } }}>
            {name}
          </Typography>
        )}
      </Stack>
    </Link>
  );
}
